module.exports = __webpack_public_path__ + "img/Animales-PALM-X6.4f6d8a4f.png";